import { validationMessagesTranslated } from '../../validation/validation-messages';
import { DynamicInput } from '../form-element-dynamic/dynamic-input';
import { FieldErrors, FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';
import { FormInput, FormInputVariants } from '../../../../@types';
import { useIntl } from 'react-intl';

type DynamicInputWrapperProps<T extends FieldValues> = {
  formFields: Record<keyof T, FormInput>;
  id: keyof T;
  register: UseFormRegister<T>;
  errors: FieldErrors<Record<keyof T, string>>;
  values: T;
  validation?: RegisterOptions;
  variant?: FormInputVariants;
  options?: {
    optionalStyle?: boolean;
    required?: boolean;
    tooltip?: string;
    label?: string;
  };
};

export const FormElementDynamicInputTyped = <T extends FieldValues>(
  props: DynamicInputWrapperProps<T>
) => {
  const { id, register, errors, values, validation, variant, formFields, options } = props;
  const intl = useIntl();
  return (
    <DynamicInput
      id={formFields[id].fieldName}
      label={options?.label ? options.label : formFields[id].label}
      type={formFields[id].type}
      validation={
        validation
          ? validation
          : options?.required
          ? { required: validationMessagesTranslated(intl).required }
          : {}
      }
      removeDecimals={formFields[id].removeDecimals}
      tooltip={options?.tooltip ? options.tooltip : formFields[id].tooltip}
      placeholder={formFields[id].placeHolder}
      error={errors[id]}
      defaultValue={values[id]}
      variant={variant}
      optionalStyle={options?.optionalStyle}
      options={formFields[id].options}
      register={register}
      layout={formFields[id].layout}
      hint={formFields[id]?.hint}
    />
  );
};
